module.exports = __webpack_public_path__ + "static/media/flow-small.e9bd3bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/flow-small.png
// module id = 628
// module chunks = 0